<template>
    <div class="page-card-secret">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理系统</el-breadcrumb-item>
            <el-breadcrumb-item>{{
                $route.meta.breadcrumb
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="page-title">{{ $route.meta.title }}</h1>

        <div class="content-card">
            <div class="toolbar-row">
                <div class="filter-row">
                    <el-input
                        v-model="search"
                        class="filter-input"
                        clearable
                        placeholder="搜索卡密账号..."
                        @keyup.enter.native="onSearch"
                        prefix-icon="el-icon-search"
                    />
                    <el-input
                        v-model="amountFilter"
                        class="filter-input"
                        clearable
                        placeholder="输入金额"
                        @keyup.enter.native="onSearch"
                    />
                    <el-select
                        @change="onSearch"
                        v-model="statusFilter"
                        placeholder="全部状态"
                        class="filter-select"
                    >
                        <el-option label="全部状态" value="" />
                        <el-option label="未发送" value="1" />
                        <el-option label="未使用" value="2" />
                        <el-option label="已使用" value="3" />
                        <el-option label="处理中" value="4" />
                    </el-select>
                    <div class="filter-actions">
                        <el-button
                            class="btn-black"
                            type="primary"
                            icon="el-icon-search"
                            @click="onSearch"
                            >查询</el-button
                        >
                        <el-button
                            icon="el-icon-refresh"
                            @click="handleResetFilters"
                            >重置</el-button
                        >
                    </div>
                </div>
                <div class="toolbar-actions">
                    <el-button
                        class="btn-black"
                        type="primary"
                        icon="el-icon-plus"
                        @click="openAddDialog"
                    >
                        新增卡密
                    </el-button>
                    <el-button icon="el-icon-document" @click="openImportDialog"
                        >Excel导入</el-button
                    >
                    <!-- <el-button icon="el-icon-download">导出Excel</el-button> -->
                    <el-button
                        class="text-danger-action"
                        icon="el-icon-delete"
                        plain
                        @click="handleBatchDelete"
                    >
                        批量删除
                    </el-button>
                    <el-dropdown
                        trigger="click"
                        class="writeoff-dropdown"
                        @command="handleWriteOffCommand"
                    >
                        <el-button type="text" class="btn-batch-writeoff">
                            <i class="el-icon-document-checked" />
                            批量核销
                            <i class="el-icon-arrow-down el-icon--right" />
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item command="sameAmount">
                                <i class="el-icon-s-grid dropdown-item-icon" />同金额批量核销
                            </el-dropdown-item> -->
                            <el-dropdown-item command="multiToCustomer">
                                <i
                                    class="el-icon-user dropdown-item-icon"
                                />给单个客户发多张卡
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button
                        icon="el-icon-refresh"
                        circle
                        @click="handleRefresh"
                    />
                </div>
            </div>

            <el-table
                ref="table"
                :data="tableData"
                v-loading="loading"
                row-key="cardId"
                stripe
                border
                height="60vh"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    reserve-selection
                />
                <el-table-column
                    align="center"
                    prop="cardNum"
                    label="卡密账号"
                />
                <el-table-column align="center" prop="cardPsw" label="密码" />
                <el-table-column align="center" label="金额" width="150">
                    <template slot-scope="scope">
                        {{
                            scope.row.cardMoney != null
                                ? `¥${Number(
                                      scope.row.cardMoney
                                  ).toLocaleString('zh-CN', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })}`
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="200"
                />
                <el-table-column align="center" label="是否绑定" width="150">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.bindingUser === '1'"
                            type="success"
                            size="small"
                            >已绑定</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.bindingUser === '0'"
                            type="warning"
                            size="small"
                            >未绑定</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column align="center" label="核销状态" width="150">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.cardStatus === '1'"
                            type="success"
                            size="small"
                            >未发送</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.cardStatus === '2'"
                            type="warning"
                            size="small"
                            >未使用</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.cardStatus === '3'"
                            type="info"
                            size="small"
                            >已使用</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.cardStatus === '4'"
                            type="danger"
                            size="small"
                            >处理中</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column align="center" label="核销详情" width="120">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-document"
                            @click="handleViewWriteOffDetail(scope.row)"
                        >
                            查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="140"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        />
                        <el-button
                            type="text"
                            class="text-danger-action"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        />
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-bar">
                <span class="pagination-info">共 {{ total }} 条</span>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @current-change="fetchData"
                />
            </div>
        </div>

        <el-dialog
            :title="isEdit ? '编辑卡密' : '新增卡密'"
            :visible.sync="addDialogVisible"
            width="480px"
            custom-class="add-card-dialog"
            :close-on-click-modal="false"
            @closed="onAddDialogClosed"
        >
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="addFormRules"
                label-position="top"
                class="add-card-form"
            >
                <el-form-item label="卡密账号" prop="cardNum">
                    <el-input
                        v-model="addForm.cardNum"
                        :disabled="isEdit"
                        clearable
                        placeholder="设置账号"
                    />
                </el-form-item>
                <el-form-item label="密码" prop="cardPsw">
                    <el-input
                        v-model="addForm.cardPsw"
                        :disabled="isEdit"
                        clearable
                        placeholder="设置随机密码"
                        show-password
                    />
                </el-form-item>
                <el-form-item label="金额" prop="cardMoney">
                    <div class="amount-with-prefix">
                        <span class="amount-prefix">¥</span>
                        <el-input-number
                            v-model="addForm.cardMoney"
                            :disabled="isEdit"
                            :precision="0"
                            :step="100"
                            :min="0"
                            :controls="false"
                            placeholder="0"
                            class="amount-input-number"
                        />
                    </div>
                </el-form-item>
                <el-form-item label="使用状态" prop="cardStatus">
                    <el-select
                        v-model="addForm.cardStatus"
                        :disabled="!isEdit"
                        placeholder="请选择"
                        style="width: 100%"
                    >
                        <el-option label="未发送" value="1" />
                        <el-option label="未使用" value="2" />
                        <el-option label="已使用" value="3" />
                        <el-option label="处理中" value="4" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="addSubmitting"
                    @click="submitAddCard"
                >
                    {{ isEdit ? '保存修改' : '确定创建' }}
                </el-button>
            </span>
        </el-dialog>

        <batch-write-off-dialog
            :visible.sync="batchWriteOffVisible"
            :card-table-data="tableData"
            :initial-tab="batchWriteOffInitialTab"
            @success="onBatchWriteOffSuccess"
            @closed="handleBatchWriteOffDialogClosed"
        />

        <el-dialog
            title="核销详情"
            :visible.sync="writeOffDetailVisible"
            width="700px"
            custom-class="writeoff-detail-dialog"
            :close-on-click-modal="false"
            append-to-body
        >
            <div v-loading="writeOffDetailLoading" class="detail-body">
                <template v-if="writeOffDetail">
                    <!-- 基本信息 -->
                    <el-descriptions :column="2" border size="small">
                        <el-descriptions-item label="卡密账号">{{
                            writeOffDetail.cardNum || '-'
                        }}</el-descriptions-item>
                        <el-descriptions-item label="密码">{{
                            writeOffDetail.cardPsw || '-'
                        }}</el-descriptions-item>
                        <el-descriptions-item label="金额">
                            {{
                                writeOffDetail.cardMoney != null
                                    ? `¥${Number(
                                          writeOffDetail.cardMoney
                                      ).toLocaleString('zh-CN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                      })}`
                                    : '-'
                            }}
                        </el-descriptions-item>
                        <el-descriptions-item label="创建时间">{{
                            writeOffDetail.createTime || '-'
                        }}</el-descriptions-item>
                        <el-descriptions-item label="核销状态">
                            <el-tag
                                v-if="writeOffDetail.cardStatus === '1'"
                                size="small"
                                >未发送</el-tag
                            >
                            <el-tag
                                v-else-if="writeOffDetail.cardStatus === '2'"
                                type="warning"
                                size="small"
                                >未使用</el-tag
                            >
                            <el-tag
                                v-else-if="writeOffDetail.cardStatus === '3'"
                                type="info"
                                size="small"
                                >已使用</el-tag
                            >
                            <el-tag
                                v-else-if="writeOffDetail.cardStatus === '4'"
                                type="danger"
                                size="small"
                                >处理中</el-tag
                            >
                            <span v-else>-</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="是否绑定">
                            <el-tag
                                v-if="writeOffDetail.bindingUser === '1'"
                                type="success"
                                size="small"
                                >已绑定</el-tag
                            >
                            <el-tag
                                v-else-if="writeOffDetail.bindingUser === '0'"
                                type="warning"
                                size="small"
                                >未绑定</el-tag
                            >
                            <span v-else>-</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="核销方式">
                            {{ getRedeemTypeLabel(writeOffDetail.redeemType) }}
                        </el-descriptions-item>
                        <el-descriptions-item
                            label="核销时间"
                            v-if="writeOffDetail.redeemTime"
                            >{{
                                writeOffDetail.redeemTime
                            }}</el-descriptions-item
                        >
                        <el-descriptions-item
                            label="绑定的客户ID"
                            v-if="writeOffDetail.ownerId"
                            >{{ writeOffDetail.ownerId }}</el-descriptions-item
                        >
                        <el-descriptions-item
                            label="绑定的客户"
                            v-if="writeOffDetail.ownerName"
                            >{{
                                writeOffDetail.ownerName
                            }}</el-descriptions-item
                        >
                        <el-descriptions-item
                            label="绑定时间"
                            v-if="writeOffDetail.bindingTime"
                            >{{
                                writeOffDetail.bindingTime
                            }}</el-descriptions-item
                        >
                        <el-descriptions-item
                            label="使用时间"
                            v-if="writeOffDetail.useTime"
                            >{{ writeOffDetail.useTime }}</el-descriptions-item
                        >
                    </el-descriptions>

                    <!-- 核销详情数据（统一从 hxOrderData 获取） -->
                    <template v-if="writeOffDetail.hxOrderData">
                        <div class="detail-section-title">
                            <i class="el-icon-document" />
                            核销详情
                        </div>
                        <el-descriptions :column="2" border size="small">
                            <el-descriptions-item label="核销单号">{{
                                writeOffDetail.hxOrderData.hxOrderNo || '-'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="交联单号">{{
                                writeOffDetail.hxOrderData.orderNo || '-'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="商户订单号">{{
                                writeOffDetail.hxOrderData.outOrderNo || '-'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="交易卡号">{{
                                writeOffDetail.hxOrderData.cardNo || '-'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="状态">
                                <el-tag
                                    v-if="
                                        writeOffDetail.hxOrderData.state === 1
                                    "
                                    type="success"
                                    size="small"
                                    >核销成功</el-tag
                                >
                                <el-tag
                                    v-else-if="
                                        writeOffDetail.hxOrderData.state === 0
                                    "
                                    type="danger"
                                    size="small"
                                    >核销失败</el-tag
                                >
                                <span v-else>{{
                                    writeOffDetail.hxOrderData.state
                                }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item
                                label="失败原因"
                                v-if="writeOffDetail.hxOrderData.failReason"
                            >
                                {{ writeOffDetail.hxOrderData.failReason }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </template>
                </template>
                <el-empty v-else description="暂无核销详情数据" />
            </div>
        </el-dialog>

        <el-dialog
            title="批量导入卡密"
            :visible.sync="importDialogVisible"
            width="560px"
            custom-class="batch-import-card-dialog"
            :close-on-click-modal="false"
            append-to-body
            @closed="onImportDialogClosed"
        >
            <div class="import-guide-box">
                <div class="import-guide-title">
                    <i class="el-icon-info" />
                    <span>操作指引</span>
                </div>
                <p class="import-guide-desc">
                    请先下载我们的标准化模板，按表格格式填写后上传，系统会自动过滤重复卡密账号。
                </p>
                <el-button
                    type="text"
                    icon="el-icon-download"
                    class="import-template-link"
                    @click="downloadImportTemplate"
                >
                    下载导入模板.xlsx
                </el-button>
            </div>

            <el-upload
                ref="importUpload"
                class="import-upload-block"
                drag
                action=""
                :http-request="noopUploadRequest"
                :auto-upload="false"
                :limit="1"
                :on-change="handleImportFileChange"
                :on-remove="handleImportFileRemove"
                accept=".xlsx,.xls"
            >
                <i class="el-icon-upload" />
                <div class="el-upload__text">点击上传或拖拽文件到这里</div>
                <div class="el-upload__tip" slot="tip">
                    仅支持 .xlsx 或 .xls 格式，文件大小不超过 10MB
                </div>
            </el-upload>

            <span slot="footer" class="import-dialog-footer">
                <el-button @click="importDialogVisible = false">关闭</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="importSubmitting"
                    @click="startBatchImport"
                >
                    开始导入
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import BatchWriteOffDialog from '@/components/BatchWriteOffDialog.vue'
import {
    getCardList,
    addCard,
    updateCard,
    importCard,
    delCard,
    getCardDetail
} from '@/api/card'

function formatCurrencyAmount(value) {
    const n = Number(value)
    if (Number.isNaN(n)) return '¥0.00'
    const s = n.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    return `¥${s}`
}

function formatNow() {
    const d = new Date()
    const pad = (x) => String(x).padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
    )} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default {
    name: 'CardSecret',
    components: {
        BatchWriteOffDialog
    },
    data() {
        const validateAmount = (rule, value, callback) => {
            if (value === undefined || value === null || value === '') {
                callback(new Error('请输入金额'))
                return
            }
            const n = Number(value)
            if (Number.isNaN(n) || n <= 0) {
                callback(new Error('金额须大于 0'))
                return
            }
            callback()
        }
        return {
            search: '',
            amountFilter: '',
            statusFilter: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            multipleSelection: [],
            batchWriteOffVisible: false,
            batchWriteOffInitialTab: 'sameAmount',
            addDialogVisible: false,
            addSubmitting: false,
            isEdit: false,
            editingCardId: null,
            importDialogVisible: false,
            importSubmitting: false,
            pendingImportFile: null,
            addForm: {
                cardNum: '',
                cardPsw: '',
                cardMoney: 0,
                cardStatus: '1'
            },
            addFormRules: {
                cardNum: [
                    {
                        required: true,
                        message: '请输入卡密账号',
                        trigger: 'blur'
                    }
                ],
                cardPsw: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                cardMoney: [
                    {
                        required: true,
                        validator: validateAmount,
                        trigger: 'blur'
                    }
                ],
                cardStatus: [
                    {
                        required: true,
                        message: '请选择使用状态',
                        trigger: 'change'
                    }
                ]
            },
            tableData: [],
            writeOffDetailVisible: false,
            writeOffDetailLoading: false,
            writeOffDetail: null
        }
    },
    mounted() {
        this.onSearch()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const result = await getCardList({
                    cardNum: this.search,
                    cardMoney: this.amountFilter,
                    cardStatus: this.statusFilter,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                this.tableData = result.rows
                this.total = result.total || 0
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.loading = false
            }
        },
        openAddDialog() {
            this.isEdit = false
            this.editingCardId = null
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                    this.$refs.addForm.resetFields()
                }
            })
        },
        handleEdit(row) {
            this.isEdit = true
            this.editingCardId = row.cardId
            this.addForm = {
                cardNum: row.cardNum,
                cardPsw: row.cardPsw,
                cardMoney: row.cardMoney,
                cardStatus: row.cardStatus != null ? String(row.cardStatus) : ''
            }
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                }
            })
        },
        onAddDialogClosed() {
            this.addSubmitting = false
            this.isEdit = false
            this.editingCardId = null
        },
        async submitAddCard() {
            try {
                if (this.isEdit) {
                    await this.$refs.addForm.validateField('cardStatus')
                } else {
                    await this.$refs.addForm.validate()
                }
            } catch {
                return
            }
            this.addSubmitting = true
            try {
                if (this.isEdit) {
                    await updateCard({
                        cardId: this.editingCardId,
                        cardStatus: this.addForm.cardStatus
                    })
                    this.$message.success('修改成功')
                } else {
                    await addCard({
                        cardNum: this.addForm.cardNum.trim(),
                        cardPsw: this.addForm.cardPsw,
                        cardMoney: this.addForm.cardMoney
                    })
                    this.$message.success('新增卡密成功')
                }
                this.addDialogVisible = false
                this.currentPage = 1
                this.fetchData()
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.addSubmitting = false
            }
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        handleRefresh() {
            this.fetchData()
        },
        handleResetFilters() {
            this.search = ''
            this.amountFilter = ''
            this.statusFilter = ''
            this.currentPage = 1
            this.fetchData()
        },
        handleDelete(row) {
            this.$confirm(`确定删除卡密「${row.cardNum}」？`, '删除确认', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async () => {
                    try {
                        await delCard([row.cardId])
                        this.$message.success('删除成功')
                        this.fetchData()
                    } catch {
                        // 错误已在 request.js 响应拦截器中处理
                    }
                })
                .catch(() => {})
        },
        handleBatchDelete() {
            const ids = this.multipleSelection.map((r) => r.cardId)
            if (!ids.length) {
                this.$message.warning('请先勾选需要删除的卡密')
                return
            }
            this.$confirm(`确定删除已选的 ${ids.length} 条卡密？`, '批量删除', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async () => {
                    try {
                        await delCard(ids)
                        this.$message.success('删除成功')
                        this.multipleSelection = []
                        this.$refs.table && this.$refs.table.clearSelection()
                        this.fetchData()
                    } catch {
                        // 错误已在 request.js 响应拦截器中处理
                    }
                })
                .catch(() => {})
        },
        handleWriteOffCommand(command) {
            this.batchWriteOffInitialTab =
                command === 'sameAmount' ? 'sameAmount' : 'singleCustomer'
            this.batchWriteOffVisible = true
        },
        async handleViewWriteOffDetail(row) {
            this.writeOffDetailVisible = true
            this.writeOffDetailLoading = true
            this.writeOffDetail = null
            try {
                const res = await getCardDetail(row.cardId)
                this.writeOffDetail = res.data || res
            } catch {
                this.writeOffDetail = null
            } finally {
                this.writeOffDetailLoading = false
            }
        },
        getRedeemTypeLabel(redeemType) {
            const map = {
                1: { text: '支付宝核销', tag: 'success' },
                2: { text: '银行卡核销', tag: 'success' },
                4: { text: '积分充值', tag: 'success' }
            }
            return map[redeemType] ? map[redeemType].text : '-'
        },
        noopUploadRequest() {},
        openImportDialog() {
            this.importDialogVisible = true
        },
        onImportDialogClosed() {
            this.importSubmitting = false
            this.pendingImportFile = null
            if (this.$refs.importUpload) {
                this.$refs.importUpload.clearFiles()
            }
        },
        downloadImportTemplate() {
            const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<body><table border="1"><tr><th>卡密账号</th><th>密码</th><th>金额</th></tr>
<tr><td>账号</td><td>随机密码</td><td>100.00</td></tr></table></body></html>`
            const blob = new Blob([`\ufeff${html}`], {
                type: 'application/vnd.ms-excel;charset=utf-8'
            })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = '卡密导入模板.xls'
            a.click()
            URL.revokeObjectURL(url)
            this.$message.success('模板已开始下载')
        },
        beforeImportUpload(file) {
            const ok = /\.(xlsx|xls)$/i.test(file.name)
            const max = 10 * 1024 * 1024
            if (!ok) {
                this.$message.error('仅支持 .xlsx 或 .xls 格式')
                return false
            }
            if (file.size > max) {
                this.$message.error('文件大小不能超过 10MB')
                return false
            }
            return true
        },
        handleImportFileChange(file, fileList) {
            const raw = file.raw
            if (!raw) return
            if (!this.beforeImportUpload(raw)) {
                this.$nextTick(() => {
                    if (this.$refs.importUpload)
                        this.$refs.importUpload.clearFiles()
                })
                return
            }
            this.pendingImportFile = raw
        },
        handleImportFileRemove() {
            this.pendingImportFile = null
        },
        async startBatchImport() {
            if (!this.pendingImportFile) {
                this.$message.warning('请先选择要导入的文件')
                return
            }
            this.importSubmitting = true
            try {
                const formData = new FormData()
                formData.append('file', this.pendingImportFile)
                await importCard(formData)
                this.importDialogVisible = false
                this.$message.success('导入成功')
                this.currentPage = 1
                this.fetchData()
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.importSubmitting = false
            }
        },
        onBatchWriteOffSuccess(payload) {
            console.log('onBatchWriteOffSuccess', payload)
            if (
                payload.mode === 'sameAmount' &&
                payload.pairs &&
                payload.pairs.length
            ) {
                const accounts = new Set(
                    payload.pairs.map((p) => p.cardAccount)
                )
                this.tableData.forEach((row) => {
                    if (accounts.has(row.account)) row.status = 'used'
                })
                this.$refs.table && this.$refs.table.clearSelection()
            }
            this.fetchData()
        },
        handleBatchWriteOffDialogClosed() {
            // 当批量核销弹窗关闭时刷新卡密列表
            this.fetchData()
        }
    }
}
</script>

<style scoped>
.import-upload-block >>> .el-upload {
    width: 100%;
}

.import-upload-block >>> .el-upload-dragger {
    width: 100%;
    padding: 28px 16px;
}

.filter-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

.filter-input {
    width: 180px;
}

.filter-select {
    width: 180px;
}

.filter-actions {
    display: flex;
    gap: 8px;
    margin-left: 8px;
}

.btn-batch-writeoff {
    color: #409eff !important;
    font-weight: normal;
    padding: 8px 10px;
}

.btn-batch-writeoff:hover,
.btn-batch-writeoff:focus {
    color: #66b1ff !important;
}

.btn-batch-writeoff i:first-child {
    margin-right: 4px;
}

.writeoff-dropdown {
    border: 1px solid #dcdfe6;
    padding: 3.5px;
    border-radius: 4px;
}

.writeoff-dropdown + .el-button {
    margin-left: 0;
}

.dropdown-item-icon {
    margin-right: 8px;
}

.pagination-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
}

.pagination-info {
    font-size: 13px;
    color: #606266;
}

.amount-with-prefix {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.amount-prefix {
    color: #909399;
    font-size: 14px;
    flex-shrink: 0;
}

.amount-input-number {
    flex: 1;
    width: 0;
}

.amount-input-number >>> .el-input__inner {
    text-align: left;
}

.import-dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}
</style>

<style>
/* dialog 挂载到 body，非 scoped */
.add-card-dialog .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 8px;
}

.add-card-dialog .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.batch-import-card-dialog .el-dialog__body {
    padding-top: 12px;
    padding-bottom: 8px;
}

.import-guide-box {
    padding: 14px 16px;
    margin-bottom: 20px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 6px;
}

.import-guide-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #409eff;
    margin-bottom: 10px;
}

.import-guide-title i {
    font-size: 16px;
}

.import-guide-desc {
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.6;
    color: #606266;
}

.import-template-link {
    padding: 0 !important;
    font-size: 13px;
}

.import-upload-block {
    width: 100%;
}

.page-card-secret .el-table__fixed-right {
    background: #fff;
    border-left: 1px solid #ebeef5;
}
.page-card-secret .el-table__fixed-right td,
.page-card-secret .el-table__fixed-right th {
    background: #fff;
}
/* 修复固定列与主表之前边框缺失、错位问题 */
.page-card-secret
    .el-table__body-wrapper
    .el-table__fixed-right
    .el-table__body {
    border-left: 1px solid #ebeef5;
}

.detail-body {
    min-height: 200px;
    padding: 4px 0;
}

.detail-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin: 20px 0 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    gap: 6px;
}

.detail-section-title i {
    font-size: 16px;
    color: #409eff;
}
</style>